export default __webpack_public_path__ + "static/media/27.f8ab59b5.mp3";